import { Typography } from '@bowtie-ins/bowkit';
import { ProductVariable } from '@bowtie-web/common';
import { Slider } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import { QuotationContextValue } from '../contexts/QuotationContext';

const EnhancedSlider = withStyles(() => ({
  thumb: {
    width: 16,
    height: 16,
    marginTop: -6,
    border: '2px solid currentColor',
  },
  track: {
    height: 4,
    borderRadius: 4,
    color: '#dcdcdc',
  },
  mark: {
    width: 6,
    height: 6,
    marginTop: -3,
    color: '#dcdcdc',
    border: '2px solid currentColor',
    borderRadius: '50%',
  },
  markActive: { backgroundColor: 'currentColor' },
}))(Slider);

type Props = {
  productVariable: ProductVariable;
  onSelectVariable: QuotationContextValue['setSelectedVariable'];
} & Pick<QuotationContextValue, 'selectedVariable'>;

const OptionSlider = ({
  productVariable,
  selectedVariable,
  onSelectVariable,
}: Props) => {
  const max = productVariable.values.length - 1;

  if (!selectedVariable) {
    return null;
  }

  return (
    <>
      <Typography variant="body-l">
        <FormattedMessage id={`${productVariable.attribute.key}.label`} />
      </Typography>
      <Typography variant="title-m" fontWeight="bold">
        {selectedVariable.value}
      </Typography>
      <EnhancedSlider
        data-cy="option-slider"
        step={1}
        min={0}
        max={max}
        marks
        value={productVariable.values.indexOf(selectedVariable)}
        onChange={(_event, newValue) => {
          if (typeof newValue === 'number') {
            onSelectVariable(productVariable.values[newValue]);
          }
        }}
        data-ui-component="Slider"
        data-ui-variant="Deductibles"
      />
    </>
  );
};

export default OptionSlider;
